import { render, staticRenderFns } from "./AuthPortal.vue?vue&type=template&id=2e50b8ea&scoped=true"
import script from "./AuthPortal.vue?vue&type=script&lang=js"
export * from "./AuthPortal.vue?vue&type=script&lang=js"
import style0 from "@pds/core/core.min.css?vue&type=style&index=0&id=2e50b8ea&prod&scoped=true&lang=css&external"
import style1 from "./AuthPortal.vue?vue&type=style&index=1&id=2e50b8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50b8ea",
  null
  
)

export default component.exports